module.exports = {
	"1": {
		"name": "Австралия",
		"short": "AU",
		"mask": "+61",
		"length": 9
	},
	"2": {
		"name": "Австрия",
		"short": "AT",
		"mask": "+43",
		"length": 9
	},
	"3": {
		"name": "Азербайджан",
		"short": "AZ",
		"mask": "+994",
		"length": 9
	},
	"5": {
		"name": "Алжир",
		"short": "DZ",
		"mask": "+213",
		"length": 9
	},
	"6": {
		"name": "Американское Самоа",
		"short": "AS",
		"mask": "+1",
		"length": 10
	},
	"7": {
		"name": "Ангилья",
		"short": "AI",
		"mask": "+1",
		"length": 10
	},
	"8": {
		"name": "Ангола",
		"short": "AO",
		"mask": "+244",
		"length": 9
	},
	"9": {
		"name": "Андорра",
		"short": "AD",
		"mask": "+376",
		"length": 6
	},
	"11": {
		"name": "Антигуа и Барбуда",
		"short": "AG",
		"mask": "+1",
		"length": 10
	},
	"12": {
		"name": "Аргентина",
		"short": "AR",
		"mask": "+54",
		"length": 11
	},
	"13": {
		"name": "Армения",
		"short": "AM",
		"mask": "+374",
		"length": 8
	},
	"14": {
		"name": "Аруба",
		"short": "AW",
		"mask": "+297",
		"length": 7
	},
	"15": {
		"name": "Афганистан",
		"short": "AF",
		"mask": "+93",
		"length": 9
	},
	"16": {
		"name": "Багамы",
		"short": "BS",
		"mask": "+1",
		"length": 10
	},
	"17": {
		"name": "Бангладеш",
		"short": "BD",
		"mask": "+880",
		"length": 10
	},
	"18": {
		"name": "Барбадос",
		"short": "BB",
		"mask": "+1",
		"length": 10
	},
	"19": {
		"name": "Бахрейн",
		"short": "BH",
		"mask": "+973",
		"length": 8
	},
	"20": {
		"name": "Белиз",
		"short": "BZ",
		"mask": "+501",
		"length": 7
	},
	"21": {
		"name": "Белоруссия",
		"short": "BY",
		"mask": "+375",
		"length": 9
	},
	"22": {
		"name": "Бельгия",
		"short": "BE",
		"mask": "+32",
		"length": 9
	},
	"23": {
		"name": "Бенин",
		"short": "BJ",
		"mask": "+229",
		"length": 8
	},
	"24": {
		"name": "Бермуды",
		"short": "BM",
		"mask": "+1",
		"length": 10
	},
	"25": {
		"name": "Болгария",
		"short": "BG",
		"mask": "+359",
		"length": 8
	},
	"26": {
		"name": "Боливия",
		"short": "BO",
		"mask": "+571",
		"length": 8
	},
	"27": {
		"name": "Босния и Герцеговина",
		"short": "BA",
		"mask": "+387",
		"length": 8
	},
	"28": {
		"name": "Ботсвана",
		"short": "BW",
		"mask": "+267",
		"length": 8
	},
	"29": {
		"name": "Бразилия",
		"short": "BR",
		"mask": "+55",
		"length": 10
	},
	"30": {
		"name": "Британская территория в Индийском океане",
		"short": "IO",
		"mask": "+246",
		"length": 7
	},
	"32": {
		"name": "Бруней",
		"short": "BN",
		"mask": "+673",
		"length": 7
	},
	"33": {
		"name": "Буркина Фасо",
		"short": "BF",
		"mask": "+226",
		"length": 8
	},
	"34": {
		"name": "Бурунди",
		"short": "BI",
		"mask": "+257",
		"length": 8
	},
	"35": {
		"name": "Бутан",
		"short": "BT",
		"mask": "+975",
		"length": 8
	},
	"36": {
		"name": "Вануату",
		"short": "VU",
		"mask": "+678",
		"length": 7
	},
	"38": {
		"name": "Великобритания",
		"short": "GB",
		"mask": "+44",
		"length": 10
	},
	"39": {
		"name": "Венгрия",
		"short": "HU",
		"mask": "+36",
		"length": 9
	},
	"40": {
		"name": "Венесуэла",
		"short": "VE",
		"mask": "+58",
		"length": 10
	},
	"42": {
		"name": "Вьетнам",
		"short": "VN",
		"mask": "+84",
		"length": 9
	},
	"43": {
		"name": "Габон",
		"short": "GA",
		"mask": "+241",
		"length": 8
	},
	"44": {
		"name": "Гаити",
		"short": "HT",
		"mask": "+509",
		"length": 8
	},
	"45": {
		"name": "Гайана",
		"short": "GY",
		"mask": "+592",
		"length": 7
	},
	"46": {
		"name": "Гамбия",
		"short": "GM",
		"mask": "+220",
		"length": 7
	},
	"47": {
		"name": "Гана",
		"short": "GH",
		"mask": "+233",
		"length": 9
	},
	"48": {
		"name": "Гваделупа",
		"short": "GP",
		"mask": "+590",
		"length": 9
	},
	"49": {
		"name": "Гватемала",
		"short": "GT",
		"mask": "+502",
		"length": 8
	},
	"50": {
		"name": "Гвинея",
		"short": "GN",
		"mask": "+224",
		"length": 8
	},
	"51": {
		"name": "Гвинея-Бисау",
		"short": "GW",
		"mask": "+245",
		"length": 7
	},
	"52": {
		"name": "Германия",
		"short": "DE",
		"mask": "+49",
		"length": 11
	},
	"53": {
		"name": "Гондурас",
		"short": "HN",
		"mask": "+504",
		"length": 8
	},
	"54": {
		"name": "Государство Палестина",
		"short": "PS",
		"mask": "+970",
		"length": 9
	},
	"55": {
		"name": "Гренада",
		"short": "GD",
		"mask": "+1",
		"length": 10
	},
	"56": {
		"name": "Гренландия",
		"short": "GL",
		"mask": "+299",
		"length": 6
	},
	"58": {
		"name": "Гуам",
		"short": "GU",
		"mask": "+1",
		"length": 10
	},
	"60": {
		"name": "Джибути",
		"short": "DJ",
		"mask": "+253",
		"length": 8
	},
	"61": {
		"name": "Доминика",
		"short": "DM",
		"mask": "+1",
		"length": 10
	},
	"62": {
		"name": "Доминиканская Республика",
		"short": "DO",
		"mask": "+1",
		"length": 10
	},
	"63": {
		"name": "Египет",
		"short": "EG",
		"mask": "+20",
		"length": 10
	},
	"64": {
		"name": "Замбия",
		"short": "ZM",
		"mask": "+260",
		"length": 9
	},
	"65": {
		"name": "Западная Сахара",
		"short": "EH",
		"mask": "+212",
		"length": 9
	},
	"66": {
		"name": "Зимбабве",
		"short": "ZW",
		"mask": "+263",
		"length": 9
	},
	"67": {
		"name": "Израиль",
		"short": "IL",
		"mask": "+972",
		"length": 9
	},
	"68": {
		"name": "Индия",
		"short": "IN",
		"mask": "+91",
		"length": 10
	},
	"69": {
		"name": "Индонезия",
		"short": "ID",
		"mask": "+62",
		"length": 9
	},
	"70": {
		"name": "Иордания",
		"short": "JO",
		"mask": "+962",
		"length": 9
	},
	"71": {
		"name": "Ирак",
		"short": "IQ",
		"mask": "+964",
		"length": 10
	},
	"72": {
		"name": "Иран",
		"short": "IR",
		"mask": "+98",
		"length": 10
	},
	"73": {
		"name": "Ирландия",
		"short": "IE",
		"mask": "+353",
		"length": 9
	},
	"74": {
		"name": "Исландия",
		"short": "IS",
		"mask": "+354",
		"length": 7
	},
	"75": {
		"name": "Испания",
		"short": "ES",
		"mask": "+34",
		"length": 9
	},
	"76": {
		"name": "Италия",
		"short": "IT",
		"mask": "+39",
		"length": 10
	},
	"77": {
		"name": "Йемен",
		"short": "YE",
		"mask": "+967",
		"length": 9
	},
	"78": {
		"name": "Кабо-Верде",
		"short": "CV",
		"mask": "+238",
		"length": 7
	},
	"79": {
		"name": "Казахстан",
		"short": "KZ",
		"mask": "+7",
		"length": 10
	},
	"80": {
		"name": "Каймановы острова",
		"short": "KY",
		"mask": "+1",
		"length": 10
	},
	"81": {
		"name": "Камбоджа",
		"short": "KH",
		"mask": "+855",
		"length": 8
	},
	"82": {
		"name": "Камерун",
		"short": "CM",
		"mask": "+237",
		"length": 8
	},
	"83": {
		"name": "Канада",
		"short": "CA",
		"mask": "+1",
		"length": 10
	},
	"84": {
		"name": "Катар",
		"short": "QA",
		"mask": "+974",
		"length": 8
	},
	"85": {
		"name": "Кения",
		"short": "KE",
		"mask": "+254",
		"length": 9
	},
	"86": {
		"name": "Кирибати",
		"short": "KI",
		"mask": "+686",
		"length": 5
	},
	"87": {
		"name": "Китайская Республика",
		"short": "TW",
		"mask": "+886",
		"length": 9
	},
	"88": {
		"name": "Korea, Democratic People's Republic of",
		"short": "KP",
		"mask": "+850",
		"length": 10
	},
	"89": {
		"name": "Кокосовые острова",
		"short": "CC",
		"mask": "+61",
		"length": 9
	},
	"90": {
		"name": "Колумбия",
		"short": "CO",
		"mask": "+57",
		"length": 10
	},
	"91": {
		"name": "Коморы",
		"short": "KM",
		"mask": "+269",
		"length": 7
	},
	"92": {
		"name": "Коста-Рика",
		"short": "CR",
		"mask": "+506",
		"length": 8
	},
	"93": {
		"name": "Кот-д’Ивуар",
		"short": "CI",
		"mask": "+255",
		"length": 8
	},
	"94": {
		"name": "Куба",
		"short": "CU",
		"mask": "+53",
		"length": 8
	},
	"95": {
		"name": "Кувейт",
		"short": "KW",
		"mask": "+965",
		"length": 7
	},
	"96": {
		"name": "Кыргызстан",
		"short": "KG",
		"mask": "+996",
		"length": 9
	},
	"97": {
		"name": "Лаос",
		"short": "LA",
		"mask": "+856",
		"length": 10
	},
	"98": {
		"name": "Лесото",
		"short": "LS",
		"mask": "+266",
		"length": 8
	},
	"99": {
		"name": "Либерия",
		"short": "LR",
		"mask": "+231",
		"length": 7
	},
	"100": {
		"name": "Ливан",
		"short": "LB",
		"mask": "+961",
		"length": 8
	},
	"101": {
		"name": "Ливия",
		"short": "LY",
		"mask": "+218",
		"length": 9
	},
	"102": {
		"name": "Литва",
		"short": "LT",
		"mask": "+218",
		"length": 9
	},
	"103": {
		"name": "Люксембург",
		"short": "LU",
		"mask": "+352",
		"length": 9
	},
	"104": {
		"name": "Маврикий",
		"short": "MU",
		"mask": "+230",
		"length": 7
	},
	"105": {
		"name": "Мавритания",
		"short": "MR",
		"mask": "+222",
		"length": 8
	},
	"106": {
		"name": "Мадагаскар",
		"short": "MG",
		"mask": "+261",
		"length": 9
	},
	"107": {
		"name": "Майотта",
		"short": "YT",
		"mask": "+262",
		"length": 9
	},
	"108": {
		"name": "Малави",
		"short": "MW",
		"mask": "+265",
		"length": 9
	},
	"109": {
		"name": "Малайзия",
		"short": "MY",
		"mask": "+60",
		"length": 9
	},
	"110": {
		"name": "Мали",
		"short": "ML",
		"mask": "+223",
		"length": 8
	},
	"111": {
		"name": "Мальдивы",
		"short": "MV",
		"mask": "+960",
		"length": 7
	},
	"112": {
		"name": "Мальта",
		"short": "MT",
		"mask": "+356",
		"length": 8
	},
	"113": {
		"name": "Марокко",
		"short": "MA",
		"mask": "+212",
		"length": 9
	},
	"114": {
		"name": "Маршалловы Острова",
		"short": "MH",
		"mask": "+692",
		"length": 7
	},
	"115": {
		"name": "Мексика",
		"short": "MX",
		"mask": "+52",
		"length": 11
	},
	"116": {
		"name": "Микронезия",
		"short": "FM",
		"mask": "+691",
		"length": 7
	},
	"117": {
		"name": "Мозамбик",
		"short": "MZ",
		"mask": "+258",
		"length": 9
	},
	"118": {
		"name": "Молдавия",
		"short": "MD",
		"mask": "+373",
		"length": 8
	},
	"119": {
		"name": "Монако",
		"short": "MC",
		"mask": "+377",
		"length": 9
	},
	"120": {
		"name": "Монголия",
		"short": "MN",
		"mask": "+976",
		"length": 8
	},
	"121": {
		"name": "Монтсеррат",
		"short": "MS",
		"mask": "+1",
		"length": 10
	},
	"122": {
		"name": "Мьянма",
		"short": "MM",
		"mask": "+95",
		"length": 8
	},
	"123": {
		"name": "Намибия",
		"short": "NA",
		"mask": "+264",
		"length": 9
	},
	"124": {
		"name": "Науру",
		"short": "NR",
		"mask": "+674",
		"length": 7
	},
	"125": {
		"name": "Непал",
		"short": "NP",
		"mask": "+977",
		"length": 10
	},
	"126": {
		"name": "Нигер",
		"short": "NE",
		"mask": "+227",
		"length": 8
	},
	"127": {
		"name": "Нигерия",
		"short": "NG",
		"mask": "+234",
		"length": 10
	},
	"129": {
		"name": "Нидерланды",
		"short": "NL",
		"mask": "+31",
		"length": 9
	},
	"130": {
		"name": "Никарагуа",
		"short": "NI",
		"mask": "+505",
		"length": 8
	},
	"131": {
		"name": "Ниуэ",
		"short": "NU",
		"mask": "+683",
		"length": 4
	},
	"132": {
		"name": "Новая Зеландия",
		"short": "NZ",
		"mask": "+64",
		"length": 9
	},
	"133": {
		"name": "Новая Каледония",
		"short": "NC",
		"mask": "+687",
		"length": 6
	},
	"134": {
		"name": "Норвегия",
		"short": "NO",
		"mask": "+47",
		"length": 8
	},
	"135": {
		"name": "ОАЭ",
		"short": "AE",
		"mask": "+971",
		"length": 9
	},
	"136": {
		"name": "Оман",
		"short": "OM",
		"mask": "+968",
		"length": 8
	},
	"138": {
		"name": "Остров Норфолк",
		"short": "NF",
		"mask": "+672",
		"length": 6
	},
	"139": {
		"name": "Остров Рождества",
		"short": "CX",
		"mask": "+61",
		"length": 9
	},
	"141": {
		"name": "Острова Кука",
		"short": "CK",
		"mask": "+682",
		"length": 5
	},
	"143": {
		"name": "Пакистан",
		"short": "PK",
		"mask": "+92",
		"length": 10
	},
	"144": {
		"name": "Палау",
		"short": "PW",
		"mask": "+680",
		"length": 7
	},
	"145": {
		"name": "Папуа - Новая Гвинея",
		"short": "PG",
		"mask": "+675",
		"length": 7
	},
	"146": {
		"name": "Парагвай",
		"short": "PY",
		"mask": "+595",
		"length": 9
	},
	"147": {
		"name": "Перу",
		"short": "PE",
		"mask": "+51",
		"length": 9
	},
	"148": {
		"name": "Польша",
		"short": "PL",
		"mask": "+48",
		"length": 9
	},
	"149": {
		"name": "Португалия",
		"short": "PT",
		"mask": "+351",
		"length": 9
	},
	"150": {
		"name": "Пуэрто-Рико",
		"short": "PR",
		"mask": "+1",
		"length": 10
	},
	"151": {
		"name": "Республика Конго",
		"short": "CG",
		"mask": "+243",
		"length": 9
	},
	"152": {
		"name": "КНДР",
		"short": "KR",
		"mask": "+82",
		"length": 10
	},
	"153": {
		"name": "Республика Македония",
		"short": "MK",
		"mask": "+389",
		"length": 8
	},
	"154": {
		"name": "Россия",
		"short": "RU",
		"mask": "+7",
		"length": 10
	},
	"155": {
		"name": "Руанда",
		"short": "RW",
		"mask": "+250",
		"length": 9
	},
	"156": {
		"name": "Румыния",
		"short": "RO",
		"mask": "+40",
		"length": 9
	},
	"157": {
		"name": "Сальвадор",
		"short": "SV",
		"mask": "+503",
		"length": 8
	},
	"158": {
		"name": "Самоа",
		"short": "WS",
		"mask": "+685",
		"length": 6
	},
	"159": {
		"name": "Сан-Марино",
		"short": "SM",
		"mask": "+378",
		"length": 8
	},
	"160": {
		"name": "Сан-Томе и Принсипи",
		"short": "ST",
		"mask": "+239",
		"length": 7
	},
	"161": {
		"name": "Саудовская Аравия",
		"short": "SA",
		"mask": "+966",
		"length": 9
	},
	"162": {
		"name": "Свазиленд",
		"short": "SZ",
		"mask": "+268",
		"length": 8
	},
	"163": {
		"name": "Северные Марианские острова",
		"short": "MP",
		"mask": "+1",
		"length": 10
	},
	"164": {
		"name": "Сейшельские Острова",
		"short": "SC",
		"mask": "+248",
		"length": 7
	},
	"165": {
		"name": "Сен-Пьер и Микелон",
		"short": "PM",
		"mask": "+508",
		"length": 6
	},
	"166": {
		"name": "Сенегал",
		"short": "SN",
		"mask": "+221",
		"length": 9
	},
	"167": {
		"name": "Сент-Винсент и Гренадины",
		"short": "VC",
		"mask": "+1",
		"length": 10
	},
	"168": {
		"name": "Сент-Китс и Невис",
		"short": "KN",
		"mask": "+1",
		"length": 10
	},
	"169": {
		"name": "Сент-Люсия",
		"short": "LC",
		"mask": "+1",
		"length": 10
	},
	"170": {
		"name": "Сербия",
		"short": "RS",
		"mask": "+381",
		"length": 9
	},
	"171": {
		"name": "Сингапур",
		"short": "SG",
		"mask": "+65",
		"length": 8
	},
	"172": {
		"name": "Сирия",
		"short": "SY",
		"mask": "+963",
		"length": 9
	},
	"173": {
		"name": "Словакия",
		"short": "SK",
		"mask": "+421",
		"length": 9
	},
	"174": {
		"name": "Словения",
		"short": "SI",
		"mask": "+386",
		"length": 8
	},
	"175": {
		"name": "Соломоновы Острова",
		"short": "SB",
		"mask": "+677",
		"length": 7
	},
	"176": {
		"name": "Сомали",
		"short": "SO",
		"mask": "+252",
		"length": 8
	},
	"177": {
		"name": "Судан",
		"short": "SD",
		"mask": "+249",
		"length": 9
	},
	"178": {
		"name": "Суринам",
		"short": "SR",
		"mask": "+597",
		"length": 7
	},
	"179": {
		"name": "Сьерра-Леоне",
		"short": "SL",
		"mask": "+232",
		"length": 8
	},
	"180": {
		"name": "Таджикистан",
		"short": "TJ",
		"mask": "+992",
		"length": 9
	},
	"181": {
		"name": "Таиланд",
		"short": "TH",
		"mask": "+66",
		"length": 9
	},
	"182": {
		"name": "Танзания",
		"short": "TZ",
		"mask": "+255",
		"length": 9
	},
	"183": {
		"name": "Тёркс и Кайкос",
		"short": "TC",
		"mask": "+1",
		"length": 10
	},
	"184": {
		"name": "Того",
		"short": "TG",
		"mask": "+228",
		"length": 8
	},
	"185": {
		"name": "Токелау",
		"short": "TK",
		"mask": "+676",
		"length": 7
	},
	"186": {
		"name": "Тонга",
		"short": "TO",
		"mask": "+676",
		"length": 7
	},
	"187": {
		"name": "Тринидад и Тобаго",
		"short": "TT",
		"mask": "+1",
		"length": 10
	},
	"188": {
		"name": "Тувалу",
		"short": "TV",
		"mask": "+688",
		"length": 6
	},
	"189": {
		"name": "Тунис",
		"short": "TN",
		"mask": "+216",
		"length": 8
	},
	"190": {
		"name": "Туркмения",
		"short": "TM",
		"mask": "+993",
		"length": 8
	},
	"191": {
		"name": "Уганда",
		"short": "UG",
		"mask": "+256",
		"length": 9
	},
	"192": {
		"name": "Узбекистан",
		"short": "UZ",
		"mask": "+998",
		"length": 9
	},
	"193": {
		"name": "Украина",
		"short": "UA",
		"mask": "+380",
		"length": 9
	},
	"194": {
		"name": "Уоллис и Футуна",
		"short": "WF",
		"mask": "+681",
		"length": 6
	},
	"195": {
		"name": "Уругвай",
		"short": "UY",
		"mask": "+598",
		"length": 8
	},
	"196": {
		"name": "Фарерские острова",
		"short": "FO",
		"mask": "+298",
		"length": 6
	},
	"197": {
		"name": "Фиджи",
		"short": "FJ",
		"mask": "+679",
		"length": 7
	},
	"198": {
		"name": "Филиппины",
		"short": "PH",
		"mask": "+63",
		"length": 10
	},
	"199": {
		"name": "Финляндия",
		"short": "FI",
		"mask": "+358",
		"length": 9
	},
	"200": {
		"name": "Фолклендские острова",
		"short": "FK",
		"mask": "+500",
		"length": 5
	},
	"201": {
		"name": "Французская Полинезия",
		"short": "PF",
		"mask": "+689",
		"length": 9
	},
	"203": {
		"name": "ЦАР",
		"short": "CF",
		"mask": "+236",
		"length": 8
	},
	"204": {
		"name": "Чад",
		"short": "TD",
		"mask": "+235",
		"length": 8
	},
	"205": {
		"name": "Черногория",
		"short": "ME",
		"mask": "+382",
		"length": 8
	},
	"206": {
		"name": "Чехия",
		"short": "CZ",
		"mask": "+420",
		"length": 9
	},
	"207": {
		"name": "Чили",
		"short": "CL",
		"mask": "+56",
		"length": 9
	},
	"208": {
		"name": "Швеция",
		"short": "SE",
		"mask": "+46",
		"length": 9
	},
	"209": {
		"name": "Шпицберген и Ян-Майен",
		"short": "SJ",
		"mask": "+47",
		"length": 8
	},
	"210": {
		"name": "Шри-Ланка",
		"short": "LK",
		"mask": "+94",
		"length": 9
	},
	"211": {
		"name": "Эквадор",
		"short": "EC",
		"mask": "+593",
		"length": 9
	},
	"212": {
		"name": "Экваториальная Гвинея",
		"short": "GQ",
		"mask": "+240",
		"length": 9
	},
	"213": {
		"name": "Эритрея",
		"short": "ER",
		"mask": "+291",
		"length": 7
	},
	"214": {
		"name": "Эстония",
		"short": "EE",
		"mask": "+372",
		"length": 8
	},
	"216": {
		"name": "ЮАР",
		"short": "ZA",
		"mask": "+27",
		"length": 9
	},
	"218": {
		"name": "Ямайка",
		"short": "JM",
		"mask": "+1",
		"length": 10
	},
	"219": {
		"name": "Япония",
		"short": "JP",
		"mask": "+81",
		"length": 10
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/fast-join-countries/ru.json
// module id = 869
// module chunks = 2